import { forwardRef, useImperativeHandle, useRef } from 'react'
import config from './config'
import { SIDRender, SLowcodeList } from 'shj-components'
import { apiData2Table } from '@/utils/data'
import { Tag } from 'antd'
import { TabComponentInterface } from '../../../index.d'
import { getCustomerTrackPlan } from '@/services/customerManage'
import { useNavigate, useParams } from 'react-router-dom'
import {openInNewTab} from "@/utils/queryParse.ts";

const Business = forwardRef<TabComponentInterface>((_, ref) => {
  const { id } = useParams()
  const navigate = useNavigate()
  const listRef = useRef<any>()

  const colors = {
    整家: 'magenta',
    整装: 'purple',
    软装: 'blue',
    零售: 'cyan',
    定制: 'cyan',
    局改: 'red',
  }

  useImperativeHandle(ref, () => ({
    openSettingModal: () => {
      listRef.current?.openSetting?.()
    },
  }))

  const fetchList = () => {
    return new Promise((resolve, reject) => {
      try {
        getCustomerTrackPlan({ customerId: id, filterStatusFlag: false }).then((res: any) => {
          resolve(apiData2Table(res))
        })
      } catch (error) {
        reject({ success: false })
      }
    })
  }

  const extension = {
    request: { fetchList },
    events: {},
    status: {},
    customRender: {
      // 线索ID渲染
      businessIdRender(_, record: Record<string, any>) {
        return (
          <SIDRender
            id={record.id}
            onClick={() => openInNewTab(`/saleOp/salesWorkBench/salesWorkBenchDetail/${record.clueId}?authKey=clueList`)}
          />
        )
      },
      // 状态渲染
      statusRender(text: any) {
        return <Tag color={'magenta'}>{text}</Tag>
      },
      // 销售阶段渲染
      saleStageRender(text: any) {
        return text ? <Tag color={'blue'}>{text}</Tag> : '-'
      },
      // 需求标签渲染
      demandTagRender(text: any) {
        return text ? <Tag color={colors[text]}>{text}</Tag> : '-'
      },
    },
  }

  return <SLowcodeList searchMode={'group'} config={config} ref={listRef} {...extension} />
})

export default Business
